import { addCardChrome } from '../chrome';
import { getActiveDiagram } from '../theme';
import { centerTextX } from './measure';
export function createStateNode(app, label, type) {
    var node = app.group();
    var isFinal = type === 'final';
    var isInitial = type === 'initial';
    if (isInitial) {
        // UML initial pseudostate — solid circle; card size = glyph for correct anchors
        var r = 9;
        var size = r * 2;
        node.metadata.diagramCardWidth = size;
        node.metadata.diagramCardHeight = size;
        node.add(app.circle({
            x: 0,
            y: 0,
            radius: r,
            fill: getActiveDiagram().stateInitialStroke,
            stroke: null,
            listening: false,
        }));
        return node;
    }
    if (isFinal) {
        // UML final: double ring with label centered inside (not below — keeps anchors tight)
        var radius = 20;
        var size = radius * 2;
        node.metadata.diagramCardWidth = size;
        node.metadata.diagramCardHeight = size;
        node.add(app.circle({
            x: 0,
            y: 0,
            radius: radius,
            fill: getActiveDiagram().stateFinalFill,
            stroke: getActiveDiagram().stateFinalStroke,
            strokeWidth: getActiveDiagram().stroke.nodeEmphasis,
            listening: false,
        }));
        node.add(app.circle({
            x: 6,
            y: 6,
            radius: radius - 6,
            fill: null,
            stroke: getActiveDiagram().stateFinalStroke,
            strokeWidth: getActiveDiagram().stroke.nodeEmphasis,
            listening: false,
        }));
        if (label) {
            var fs_1 = getActiveDiagram().fontSize.sm;
            node.add(app.text({
                text: label,
                x: centerTextX(label, size, fs_1),
                y: size / 2 - fs_1 / 2 - 1,
                fontSize: fs_1,
                fontWeight: '600',
                fontFamily: getActiveDiagram().fontFamily,
                fill: getActiveDiagram().stateFinalStroke,
                listening: false,
            }));
        }
        return node;
    }
    var w = 112;
    var h = 42;
    node.metadata.diagramCardWidth = w;
    node.metadata.diagramCardHeight = h;
    // Clean Mermaid-style pill — stroke only, no accent bar / sheen artifacts
    addCardChrome(app, node, {
        width: w,
        height: h,
        cornerRadius: getActiveDiagram().radii.pill,
        fill: getActiveDiagram().stateFill,
        stroke: getActiveDiagram().stateStroke,
        strokeWidth: getActiveDiagram().stroke.nodeEmphasis,
        shadow: null,
        sheen: false,
    });
    var fs = getActiveDiagram().fontSize.md;
    node.add(app.text({
        text: label,
        x: centerTextX(label, w, fs),
        y: h / 2 - fs / 2 - 1,
        fontSize: fs,
        fontWeight: '600',
        fontFamily: getActiveDiagram().fontFamily,
        fill: getActiveDiagram().nodeText,
        listening: false,
    }));
    return node;
}
